import { render, staticRenderFns } from "./AtomPinVideo.vue?vue&type=template&id=f1859704&"
import script from "./AtomPinVideo.vue?vue&type=script&lang=js&"
export * from "./AtomPinVideo.vue?vue&type=script&lang=js&"
import style0 from "./AtomPinVideo.vue?vue&type=style&index=0&id=f1859704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports